// Aviso de privacidad de Atlantis International. El enlace queda apagado hasta que el director publique
// la página /aviso-de-privacidad (decisión del 24-oct-2026); entonces cambiar AVISO_PUBLICADO a true.
export const AVISO_PUBLICADO = false;
export const AVISO_URL = "https://www.atlantisintlsourcing.com/aviso-de-privacidad";
export const AVISO_HREF = AVISO_PUBLICADO ? AVISO_URL : "#";
// Mapa de correos: el único correo comercial que se da al público.
export const CORREO_CONTACTO = "contact@atlantisintlsourcing.com";
